import { useState } from 'react';
import apiClient from '../../../services/apiClientService';
import { useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import { Routes } from '../../../routes/RouteConstants';

// One provider's calendar (docs/MULTI_PROVIDER.md); the dashboard always names one.
const useGetBookedSlotSchedules = (providerId) => {
  const { tenantId } = useTenant();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  // Resolves to the page, or `null` on failure. Publishes nothing: a background refresh pages
  // through this so it cannot interleave with a reload that is paging through `data`.
  const fetchBookedSlotSchedules = async (startDate) => {
    try {
      const response = await apiClient.get(`/v1/tenants/${tenantId}/daily-schedules`, {
        params: {
          startDate: startDate.format('YYYY-MM-DD'),
          providerId,
        },
      });
      return response.data;
    } catch (error) {
      handleError(error, Routes.DASHBOARD);
      return null;
    }
  };

  const getBookedSlotSchedules = async (startDate) => {
    setLoading(true);
    const page = await fetchBookedSlotSchedules(startDate);
    if (page) setData(page);
    setLoading(false);
  };

  return { data, loading, getBookedSlotSchedules, fetchBookedSlotSchedules };
};

export default useGetBookedSlotSchedules;